export const HOME_PATH = "/";

export const ABOUT_PATH = "/about";
export const PRIVACY_PATH = "/privacy-policy";
export const TERMS_PATH = "/terms";

export const CODE_HOME_PATH = "/code";
export const POSTS_HOME_PATH = "/code/posts";
export const USEFUL_TOOLS_AND_CODE_HOME_PATH = "/code/useful-tools-and-code";

// NEW_POST: Posts section of routes
export const MERGE_INTERVALS_POST = "/code/posts/merge-intervals";
export const DEPENDENCY_INJECTION_POST = "/code/posts/dependency-injection";
export const VALID_PARENTHESES_POST = "/code/posts/valid-parentheses";
export const RECURSION_POST = "/code/posts/recursion";
export const COLOR_CONVERT_POST = "/code/posts/color-convert";
export const HELLO_ISSUES_POST = "/code/posts/hello-issues";
export const HELLO_WORLD_POST = "/code/posts/hello-world";
export const MY_FIRST_VIBE_REFACTOR_POST =
  "/code/posts/my-first-vibe-refactor";
export const MY_FIRST_REAL_VIBE_POST = "/code/posts/my-first-real-vibe";
export const VIBE_TUNE_TOO_POST = "/code/posts/vibe-tune-too";

// NEW_USEFUL_TOOL: Useful tools and code section of routes
export const BUTTON_WITH_SELECT_TOOL =
  "/code/useful-tools-and-code/button-with-select";
export const COLOR_CONVERTER_TOOL = "/code/useful-tools-and-code/color-converter";
export const CONFETTI_TOOL = "/code/useful-tools-and-code/confetti";

export const FOOD_HOME_PATH = "/food";

// NEW_RECIPES: Recipes section of routes
export const BEEF_NEGIMAKI_RECIPE = "/food/beef-negimaki";
export const BEEF_STIR_FRY_RECIPE = "/food/beef-stir-fry";
export const BEEF_SUKIYAKI_RICE_BOWL_RECIPE = "/food/beef-sukiyaki-rice-bowl";
export const BEER_BATTERED_FISH_RECIPE = "/food/beer-battered-fish";
export const BLACK_BEAN_FLAUTAS_RECIPE = "/food/black-bean-flautas";
export const BRAISED_CHICKEN_RECIPE = "/food/braised-chicken";
export const CAULIFLOWER_HOT_WINGS_RECIPE = "/food/cauliflower-hot-wings";
export const CHICKEN_MARSALA_RECIPE = "/food/chicken-marsala";
export const CHICKEN_TIKKA_MASALA_RECIPE = "/food/chicken-tikka-masala";
export const CREAMY_CHICKEN_RECIPE = "/food/creamy-chicken";
export const CRISPY_BAKED_CHICKEN_FLAUTAS_RECIPE =
  "/food/crispy-baked-chicken-flautas";
export const FRIED_CHICKEN_NUGGETS_RECIPE = "/food/fried-chicken-nuggets";
export const FRIED_POTATOES_AND_ONNIONS_RECIPE =
  "/food/fried-potatoes-and-onions";
export const GAMJA_JORIM_KOREAN_BRAISED_POTATOES_RECIPE =
  "/food/gamja-jorim-korean-braised-potatoes";
export const GENERAL_TSOS_CHICKEN_RECIPE = "/food/general-tsos-chicken";
export const GRANOLA_RECIPE = "/food/granola";
export const JAPANESE_CHICKEN_DON_RECIPE = "/food/japanese-chicken-don";
export const KOREAN_LETTUCE_WRAPS_RECIPE = "/food/korean-lettuce-wraps";
export const KUNG_PAO_CHICKEN_RECIPE = "/food/kung-pao-chicken";
export const LEMON_GARLIC_BOK_CHOY_RECIPE = "/food/lemon-garlic-bok-choy";
export const MISO_GARLIC_CAULIFLOWER_BITES_RECIPE =
  "/food/miso-garlic-cauliflower-bites";
export const NOBO_MISO_MARINATED_FISH_RECIPE = "/food/nobu-miso-marinated-fish";
export const ONE_PAN_ORECCHIETTE_PASTA_RECIPE =
  "/food/one-pan-orecchiette-pasta";
export const OVEN_ROASTED_COLA_BRAISED_PULLED_PORK_RECIPE =
  "/food/oven-roasted-cola-braised-pulled-pork";
export const PAD_THAI_RECIPE = "/food/pad-thai";
export const PORK_TENDERLOIN_RECIPE = "/food/pork-tenderloin";
export const REVERSE_SEAR_TRI_TIP_RECIPE = "/food/reverse-sear-tri-tip";
export const RICE_PILAF_RECIPE = "/food/rice-pilaf";
export const SKAGENRORA_RECIPE = "/food/skagenrora";
export const SPAGHETTI_BOLOGNESE_RECIPE = "/food/spaghetti-bolognese";
export const STOVE_TO_OVEN_STEAK_RECIPE = "/food/stove-to-oven-steak";
export const TACOS_DE_CARNITAS_RECIPE = "/food/tacos-de-carnitas";
export const YAKI_SORTA_RECIPE = "/food/yaki-sorta";
export const ZAATAR_CHICKEN_BURGERS_RECIPE = "/food/zaatar-chicken-burgers";
export const ZAATAR_ROASTED_CHICKEN_RECIPE = "/food/zaatar-roasted-chicken";
